import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useOffTakersList } from "../../api/offTaker";
import { getStatusColor } from "../../util/statusColor";
import { useNavigate } from "react-router-dom";
import { useOrganizationsList } from "../../api/organization";

type offTakerTableProps = {
  searchText: string;
};

const offTakerColumn = [
  {
    title: "No.",
    width: 60,
    render: (text: string, record: any, index: number) => <b>#{index + 1}</b>,
  },
  {
    dataIndex: "name",
    title: "Name",
  },
  {
    dataIndex: "email",
    title: "Email",
  },
  {
    dataIndex: "phoneNo",
    title: "Phone number",
  },
  {
    dataIndex: "status",
    title: "Status",
    render: (text: string, record: any) => {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "80%",
            paddingTop: 6,
            paddingBottom: 6,
            borderRadius: 8.5,
            color: getStatusColor(text),
            backgroundColor: `${getStatusColor(text)}44`,
          }}
        >
          {text}
        </div>
      );
    },
  },
];

const OffTakersTable: React.FC<offTakerTableProps> = ({ searchText }) => {
  const { data: offTakers, isLoading } = useOrganizationsList({
    merchantType: "OFF_TAKERS",
  });

  const [tableData, setTableData] = useState<
    { id: Number; name: string; email: string; phoneNo: string | number }[]
  >([]);

  useEffect(() => {
    if (searchText && offTakers && offTakers.data && offTakers.data.data) {
      const _tableData = offTakers.data.data
        .filter((item: any) => {
          return (
            item.name.toLowerCase().indexOf(searchText.toLowerCase()) >= 0 ||
            item.email.toLowerCase().indexOf(searchText.toLowerCase()) >= 0 ||
            item.phoneNo.toLowerCase().indexOf(searchText.toLowerCase()) >= 0 ||
            item.status.toLowerCase().indexOf(searchText.toLowerCase()) >= 0
          );
        })
        .map((item: any) => {
          return {
            id: item.id,
            name: item.name,
            email: item.email,
            phoneNo: item.phoneNo,
            status: item.status,
          };
        });

      setTableData(_tableData);
    } else {
      const _tableData = offTakers?.data?.data?.content.map((item: any) => {
        return {
          id: item.id,
          name: item.name,
          email: item.email,
          phoneNo: item.phoneNo,
          status: item.status,
        };
      });

      setTableData(_tableData);
    }
  }, [searchText, offTakers]);

  return (
    <>
      <Table
        style={{
          cursor: "pointer",
          position: "relative",
          zIndex: 100,
          overflowY: "hidden",
        }}
        scroll={{ y: 600 }}
        className="hidden md:block"
        dataSource={tableData}
        columns={offTakerColumn}
        loading={isLoading}
      />
      <div className="block md:hidden">
        <div className="text-white mt-4 text-2xl border-b-[1px] border-gray-500">
          Off takers
        </div>
        {tableData && tableData.length > 0 ? (
          tableData.map((item: any) => (
            <div
              key={item.id}
              className="flex justify-between items-center py-2 border-b-2 border-gray-500"
            >
              <div className="flex flex-col gap-1 w-full text-white">
                <div className="text-xl">{item.name}</div>
                <div>Email - {item.email}</div>
                <div>Tel. - {item.phoneNumber}</div>
              </div>
              <div
                style={{
                  color: getStatusColor(item.status),
                  backgroundColor: `${getStatusColor(item.status)}44`,
                }}
                className={`flex justify-center items-center py-2 px-4 rounded-xl w-[150px]`}
              >
                {item.status}
              </div>
            </div>
          ))
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default OffTakersTable;
